/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Incode_SecondsInputs */



/**
* | output |
* | --- |
* | "Incode (Seconds)" |
*
* @param {Incode_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const incode_seconds = /** @type {((inputs?: Incode_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Incode_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incode (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Incodieren (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incode (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Входящий код (секунды)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incode (Segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编码（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インコード（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इनकोड (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incode (segundos)")
	return /** @type {LocalizedString} */ ("Incode (Seconds)")
});